import clsx from 'clsx'

import { styles } from './styles'

import ButtonLink from '@lno/core/components/ButtonLink'
import { GASelectContentEvent } from '@lno/core/modules/analytics/events'
import { DesenrolaNorthEast } from './components'
const jsxScope = `jsx-${styles.__hash}`

interface Props {
  className?: string
}

export function DesenrolaNorthEastSection({ className }: Props) {
  const CTA_LABEL = 'Conferir ofertas'
  const LINK =
    'https://www.serasa.com.br/entrar?redirectUrl=/area-cliente/solucoes/negociar'
  const handleClick = () => {
    return GASelectContentEvent.checkDiscounts(CTA_LABEL)
  }

  return (
    <section className={clsx('desenrola-north-east-section', className)}>
      <div
        className={clsx(
          'desenrola-north-east-section__content-wrapper',
          className
        )}
      >
        <DesenrolaNorthEast.Title />
        <DesenrolaNorthEast.Image />
        <DesenrolaNorthEast.Description />
        <ButtonLink
          href={LINK}
          color="primary"
          onClick={handleClick}
          className={clsx(jsxScope, 'desenrola-north-east-section__button')}
        >
          {CTA_LABEL}
        </ButtonLink>
      </div>
      <style jsx>{styles}</style>
    </section>
  )
}

DesenrolaNorthEastSection.defaultProps = {}

export default DesenrolaNorthEastSection
